/**
 * Department-based routing utilities
 * Routes users to their department module after login
 */

export interface User {
  id: number;
  name: string | null;
  email: string | null;
  role: 'operator' | 'admin' | 'supervisor';
  department: 'water' | 'wastewater' | 'traffic' | null;
}

/**
 * Get the post-login route based on user role and department
 */
export function getPostLoginRoute(user: User): string {
  // Admin goes to main dashboard (current home page with all modules)
  if (user.role === 'admin') {
    return '/';
  }
  
  // Operators and Supervisors go to their department module
  switch (user.department) {
    case 'water':
      return '/'; // Water module is the current main application
    case 'wastewater':
      return '/wastewater';
    case 'traffic':
      return '/traffic';
    default:
      // Fallback if no department assigned (shouldn't happen with validation)
      return '/';
  }
}

/**
 * Get department display name
 */
export function getDepartmentName(department: 'water' | 'wastewater' | 'traffic' | null): string {
  switch (department) {
    case 'water':
      return 'Water Department';
    case 'wastewater':
      return 'Wastewater Department';
    case 'traffic':
      return 'Traffic Department';
    default:
      return 'No Department';
  }
}

/**
 * Get module name for department
 */
export function getModuleName(department: 'water' | 'wastewater' | 'traffic' | null): string {
  switch (department) {
    case 'water':
      return 'Water — Well Logging';
    case 'wastewater':
      return 'Wastewater — Treatment Operations';
    case 'traffic':
      return 'Traffic — Signal Maintenance';
    default:
      return 'Municipal Portal';
  }
}
